/**
 * The product name lives here and in the i18n files / package.json names only.
 * Rename the product by changing this constant (and `app.name` in hr.json / en.json).
 */
export const PRODUCT = {
  name: "Mandrac",
  /** lowercase identifier used for cookie names, storage keys, worker names */
  slug: "mandrac",
} as const;

export const SESSION_COOKIE = `${PRODUCT.slug}_session`;
export const CSRF_COOKIE = `${PRODUCT.slug}_csrf`;
export const CSRF_HEADER = "x-csrf-token";
export const DEVICE_HEADER = "x-device-token";
